<button class="custom-button" [ngClass]="color" [disabled]="disabled" (click)="onClick()" [attr.data-id]="label">
    @if (iconBefore) {

        @if (isImagePath(iconBefore)) {
<img [src]="iconBefore" alt="" class="icon-img before" />
}
        @if (!isImagePath(iconBefore)) {
<i [class]="iconBefore" class="icon before"></i>
}
    
}
    <span>{{ label }}</span>
    @if (iconAfter) {

        @if (isImagePath(iconAfter)) {
<img [src]="iconAfter" alt="" class="icon-img after" />
}
        @if (!isImagePath(iconAfter)) {
<i [class]="iconAfter" class="icon after"></i>
}
    
}
</button>